import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import MethodsClass from "../../../utils/method";
import { sendAsyncMetric } from '.';
import { fix, requestIdleInterval, isDomFocus } from "../../utils";
var Methods = new MethodsClass();
export var startNetworkPing = function startNetworkPing(taskRef) {
  var _taskRef$value;
  var _ref = ((_taskRef$value = taskRef.value) === null || _taskRef$value === void 0 ? void 0 : _taskRef$value.ctx) || {},
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var networkPingInterval = options.networkPingInterval;
  calcNetJitter({
    interval: networkPingInterval
  }, function (res) {
    var type = res.type,
      value = res.value;
    if (!isDomFocus()) return;
    console.log('[Measurements] NetworkPing', type, value);
    var val = "".concat(Date.now(), "|").concat(fix(value.ping), "|").concat(fix(value.jitter));
    sendAsyncMetric(taskRef.value, {
      type: type,
      value: val
    });
  });
};
var TIME_OUT = 5 * 1000;
var NET_SPEED_IMG_BIG = 'https://img1.zhuanstatic.com/common/img/logo-64x64.png';
var NET_SPEED_IMG_SMALL = 'https://pic5.zhuanstatic.com/zhuanzh/8a208a4e-9d33-4c22-b6d9-b0db1574c7e6.png';
export var calcNetPing = function calcNetPing() {
  return new Promise(function (resolve) {
    var res = {
      value: TIME_OUT
    };
    // 超时兜底
    var timer = setTimeout(function () {
      clearTimeout(timer);
      timer = null;
      res.value = TIME_OUT;
      resolve(res);
    }, TIME_OUT);
    try {
      var performance = window.performance;
      var smallImgData = window['netSpeedSmallImg'] || (window['netSpeedSmallImg'] = {});
      var imgData = window['netSpeedImg'] || (window['netSpeedImg'] = {});
      var _unique = Methods.getUnique();
      var smallImg = smallImgData[_unique] = new Image();
      var img = imgData[_unique] = new Image();
      var start = 0;
      smallImg.onload = smallImg.onerror = function () {
        smallImg.onload = smallImg.onerror = null;
        smallImg = smallImgData[_unique] = null;
        // 小图片加载完 打点 start
        start = performance.now ? performance.now() : +new Date();
        // 再加载一张大图，用于计算加载大图加载时间差
        img.src = NET_SPEED_IMG_BIG + '?_unique=' + _unique;
      };
      // 先加载一张小图，小图加载完后 再加载一张大图 用于计算，减少资源排队的影响
      smallImg.src = NET_SPEED_IMG_SMALL + '?_unique=' + _unique;
      img.onload = img.onerror = function () {
        img.onload = img.onerror = null;
        img = imgData[_unique] = null;
        // 大图片加载完 打点 end, 计算加载大图加载时间差
        var time = performance.now ? performance.now() - start : +new Date() - start;
        var netTime = parseInt(time.toString(), 10) || 0;
        res.value = netTime;
        resolve(res);
      };
    } catch (err) {
      // console.error(err)
      // 图片加载出错 30003
      resolve(res);
    }
  });
};
export var calcNetJitter = function calcNetJitter() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  var pingQueue = [];
  var interval = opt.interval;
  var step = Math.ceil(interval / 5);
  var max = -Infinity;
  var min = Infinity;
  var jitter = 0;
  var isFirst = 1;
  var cancel = requestIdleInterval(function () {
    calcNetPing().then(function (_ref2) {
      var value = _ref2.value;
      if (isFirst) {
        cb({
          type: 'networkping',
          value: {
            ping: value,
            jitter: 0
          },
          cancel: cancel
        });
        isFirst = 0;
        return;
      }
      pingQueue.push(value);
      if (pingQueue.length % 5 === 0) {
        max = Math.max.apply(Math, _toConsumableArray(pingQueue));
        min = Math.min.apply(Math, _toConsumableArray(pingQueue));
        // 差值
        jitter = fix(max - min);
        // 均值
        var val = Math.ceil(pingQueue.reduce(function (a, b) {
          return a + b;
        }, 0) / pingQueue.length);
        // console.log('pingQueue pingQueue.length % 5 ', pingQueue, pingQueue.length % 5, val, jitter)
        cb({
          type: 'networkping',
          value: {
            ping: val,
            jitter: jitter
          },
          cancel: cancel
        });
        pingQueue = [];
      }
    });
  }, step);
};